import React, { Children, ReactNode } from "react";
import styled from "styled-components";

interface IBottomFixedProps {
  children: ReactNode;
}

const BottomFixed = (props: IBottomFixedProps) => {
  return <BottomFixedWrap>{props.children}</BottomFixedWrap>;
};

const BottomFixedWrap = styled.div`
  z-index: 1000;
  position: fixed;
  right: 15px;
  bottom: 75px;
`;

export default BottomFixed;
